<template>
  <b-iconstack v-bind="$attrs">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 1024 1024"
    >
      <path fill-rule="evenodd" :d="path" :name="iconame"></path>
    </svg>
  </b-iconstack>
</template>
<script>
import { getIcons } from "@/components/Icon/icons";

export default {
  name: "Icon",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      iconame: "",
      path: "",
    };
  },
  mounted() {
    this.setPath();
  },
  methods: {
    setPath() {
      const icons = getIcons();
      this.path = icons.get(this.name);
      this.iconame = this.name;
    },
  },
};
</script>
